import React from 'react';
import { Card } from 'antd';
import PostCard from '../components/PostCard/PostCard';

function formatMonthYear(key) {
  const [year, month] = key.split('-');
  return `${year}-${month}`;
}

export default function Archive({ posts = [] }) {
  // 按年-月分组
  const groups = {};
  posts.forEach((p) => {
    const d = new Date(p.createdAt);
    const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    if (!groups[key]) groups[key] = [];
    groups[key].push(p);
  });

  const keys = Object.keys(groups).sort((a, b) => (a < b ? 1 : -1));

  return (
    <div>
      <h2>文章归档</h2>
      {keys.length === 0 ? (
        <p>尚无文章归档。</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          {keys.map((k) => (
            <div key={k}>
              <h3 style={{ marginBottom: 12 }}>{formatMonthYear(k)} ({groups[k].length})</h3>
              <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                {groups[k].sort((a, b) => b.createdAt - a.createdAt).map((p) => (
                  <div key={p.id} style={{ width: 320 }}>
                    <PostCard post={p} actions={null} />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
